export default "__VITE_ASSET__Xh$WTcvr__"